import { CONF_API_URL } from 'utils/config';
import { useApiQuery } from 'hooks/useApiQuery';
import { IConsultationDetails } from 'utils/models';

export type ConsultationDetailsResponse = {
  code?: number | string;
  success?: boolean;
  message?: string;
  consultation?: IConsultationDetails;
};

export const useConsultationDetails = (id?: string) => {
  const url = id
    ? `${CONF_API_URL}api/hazel/consultations/get-consultation-details?consultationId=${encodeURIComponent(
        id
      )}`
    : '';

  return useApiQuery<ConsultationDetailsResponse, ConsultationDetailsResponse>(
    ['consultationDetails', id ?? ''],
    url,
    { enabled: !!id, staleTime: 30_000 }
  );
};
